import { render, staticRenderFns } from "./newsView.vue?vue&type=template&id=324ef8fd&scoped=true&"
import script from "./newsView.js?vue&type=script&lang=js&"
export * from "./newsView.js?vue&type=script&lang=js&"
import style0 from "./newsView.scss?vue&type=style&index=0&id=324ef8fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ef8fd",
  null
  
)

export default component.exports